import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import BlogPostCard from './BlogPostCard';
import { getAllPosts } from '../../data/blogIndex';
import SEOHead from '../SEO/SEOHead';

const BlogListing = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const posts = getAllPosts();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = ['All', ...new Set(posts.map((p) => p.category))];

  const filteredPosts =
    selectedCategory === 'All'
      ? posts
      : posts.filter((p) => p.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Blog - Insights on AI, Cloud Strategy & Engineering Leadership"
        description="Technical perspectives on cloud strategy, AI adoption, data architecture, and the future of enterprise technology from North, fractional CTO and technology consulting with 15+ years experience."
        path="/blog"
      />
      {/* Header */}
      <div className="bg-gradient-to-br from-pink-50 via-white to-cream pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center px-4 py-2 bg-white/60 backdrop-blur-sm rounded-full mb-8 border border-gray-100"
            >
              <span className="text-sm font-medium text-muted-grey">
                Insights & Analysis
              </span>
            </motion.div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-dark-slate mb-6 tracking-tight">
              The North
              <br />
              <span className="text-muted-blue-grey">Blog</span>
            </h1>

            <p className="text-xl text-muted-grey max-w-3xl mx-auto leading-relaxed">
              Technical perspectives on cloud strategy, AI adoption, data architecture,
              and the future of enterprise technology. Written from the trenches.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Category Filter */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-wrap gap-3 justify-center">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                selectedCategory === category
                  ? 'bg-dark-slate text-white'
                  : 'bg-gray-50 text-muted-grey hover:bg-gray-100'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Posts Grid */}
      <div className="max-w-7xl mx-auto px-6 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredPosts.map((post, index) => (
            <BlogPostCard
              key={post.id}
              post={post}
              delay={index * 0.05}
            />
          ))}
        </div>

        {filteredPosts.length === 0 && (
          <div className="text-center py-16">
            <p className="text-muted-grey text-lg">No articles found in this category.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogListing;
